import { Tab, Tabs } from '@structural-climbing/ui'

/**
 * A short either/or (two or three words each): HeroUI's solid Tabs, used as a
 * segmented control. Longer choices that need a sentence use OptionCards.
 */
export function Segmented<T extends string>({
  label,
  value,
  onChange,
  options,
  fullWidth,
  isDisabled,
}: {
  label: string
  value: T
  onChange: (value: T) => void
  options: { value: T; label: string; isDisabled?: boolean }[]
  fullWidth?: boolean
  isDisabled?: boolean
}) {
  return (
    <Tabs
      aria-label={label}
      selectedKey={value}
      onSelectionChange={(key) => onChange(String(key) as T)}
      fullWidth={fullWidth}
      isDisabled={isDisabled}
      disabledKeys={options.filter((o) => o.isDisabled).map((o) => o.value)}
      classNames={{
        base: fullWidth ? 'w-full' : 'max-w-full',
        tabList: `max-w-full overflow-x-auto scrollbar-hide gap-1 bg-default-100 p-1 ${fullWidth ? 'w-full' : ''}`,
        tab: fullWidth ? 'flex-1 px-3 h-10' : 'w-auto px-4 h-10',
        cursor: 'bg-content1 shadow-sm',
        tabContent:
          'text-foreground/70 group-data-[selected=true]:font-semibold group-data-[selected=true]:text-foreground',
      }}
    >
      {options.map((o) => (
        <Tab key={o.value} title={o.label} />
      ))}
    </Tabs>
  )
}
